import { useState, useEffect } from 'react';
import cookieService from '../services/cookieService';

// Module-level variables (shared across all hook instances)
let hasPerformedInitialCheck = false;
let buttonShouldBeShown = false;
const subscribers = new Set();

// Notification function
const notifySubscribers = () => {
  subscribers.forEach((callback) => callback());
};

/**
 * Custom hook to check for livesession cookie and manage button visibility across pages
 */
function useLiveSessionCheck() {
  const [showButton, setShowButton] = useState(buttonShouldBeShown);

  const checkLiveSession = () => {
    let hasLiveSession = false;
    const livesessionValue = cookieService.getCookie('livesession');
    if (livesessionValue) {
      const timestamp = parseInt(livesessionValue, 10);
      const timeDifference = Date.now() - timestamp;
      const maxAge = 35 * 60 * 1000; // 35 minutes in milliseconds

      hasLiveSession =
        !Number.isNaN(timestamp) && timeDifference <= maxAge;
    }

    // const hasLiveSession = !!cookieService.getCookie('livesession');
    const newButtonState = !hasLiveSession;

    // Only update if changed
    if (buttonShouldBeShown !== newButtonState) {
      buttonShouldBeShown = newButtonState;
      notifySubscribers();
    }
  };

  useEffect(() => {
    // Subscribe to notifications
    const handleButtonStateChange = () => {
      setShowButton(buttonShouldBeShown);
    };

    subscribers.add(handleButtonStateChange);

    // Initial state setup - immediately show button if previous check determined it should be shown
    setShowButton(buttonShouldBeShown);

    // Create a listener for the popupClosed event
    const handlePopupClosed = () => {
      // Re-check cookie after popup is closed
      setTimeout(checkLiveSession, 500);
    };

    window.addEventListener('popupClosed', handlePopupClosed);
    let initialCheckTimeout;

    // Only perform the delayed initial check once across the entire app
    if (!hasPerformedInitialCheck) {
      // Default to hidden initially
      buttonShouldBeShown = false;
      hasPerformedInitialCheck = true;

      // Do the first check after a delay
      initialCheckTimeout = setTimeout(() => {
        console.log(
          '[MCP Session Check] Performing initial livesession check after 20s',
        );

        checkLiveSession();
      }, 20000);

      return () => {
        //  clearTimeout(initialCheckTimeout);
        subscribers.delete(handleButtonStateChange);
      };
    }

    // For subsequent component mounts, just clean up the event listeners
    return () => {
      clearTimeout(initialCheckTimeout);
      subscribers.delete(handleButtonStateChange);
      window.removeEventListener('popupClosed', handlePopupClosed);
    };
  }, []);

  return {
    showButton,
  };
}

export default useLiveSessionCheck;
